// @ts-strict-ignore
//import React, { Component} from 'react';
import { defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
    YEARLY: {
        defaultMessage: 'One per year',
        description: 'Survey schedule frequency',
    },
    TWICE_YEARLY: {
        defaultMessage: 'Two per year',
        description: 'Survey schedule frequency',
    },
    QUARTERLY: {
        defaultMessage: 'Four per year',
        description: 'Survey schedule frequency',
    },
    END_OF_PROJECT: {
        defaultMessage: 'End of project',
        description: 'Survey schedule frequency',
    },
    OTHER: {
        defaultMessage: 'Other',
        description: 'Survey schedule frequency',
    },
    recommended: {
        defaultMessage: 'Recommended',
        description: 'The default recommended survey schedule',
    },
    startDate: {
        defaultMessage: 'Start date',
        description: 'Form label',
    },
    endDate: {
        defaultMessage: 'End date',
        description: 'Form label',
    },
});

function SurveyScheduleLabel(props: any) {
    const {
        intl: { formatMessage },
        id,
    } = props;
    if (id) {
        return formatMessage(messages[id]);
    }
}

export default injectIntl(SurveyScheduleLabel);
